import { useCurrency } from "../lib/currency";

export default function CurrencyToggle() {
  const { currency, setCurrency } = useCurrency();
  const isCVE = currency === "CVE";
  return (
    <div
      className="inline-flex items-center rounded-full border border-border bg-white/70 p-1 text-xs font-semibold"
      data-testid="currency-toggle"
    >
      <button
        type="button"
        onClick={() => setCurrency("CVE")}
        className={`px-3 py-1.5 rounded-full transition-colors ${isCVE ? "bg-[hsl(var(--primary))] text-white shadow-sm" : "text-muted-foreground hover:text-foreground"}`}
        data-testid="currency-cve-btn"
      >
        CVE
      </button>
      <button
        type="button"
        onClick={() => setCurrency("EUR")}
        className={`px-3 py-1.5 rounded-full transition-colors ${!isCVE ? "bg-[hsl(var(--primary))] text-white shadow-sm" : "text-muted-foreground hover:text-foreground"}`}
        data-testid="currency-eur-btn"
      >
        €
      </button>
    </div>
  );
}
